import type { IIdName } from "@octopusdeploy/octopus-server-client";
export const toSelectItem = <T extends IIdName>(item: T) => ({ value: item.Id, text: item.Name });
export default toSelectItem;
